import { useLanguage } from '@/i18n/LanguageContext';
import { NumberInput, type NumberInputProps } from '@mantine/core';

const ACCEPTED_DECIMAL_SEPARATORS = ['.', ','];

/**
 * Number input that follows the selected UI language while accepting both
 * common decimal separators. Mantine otherwise ignores commas by default,
 * which can turn input such as "14,40" into 1440.
 */
export function LocalizedNumberInput({
  decimalSeparator,
  allowedDecimalSeparators,
  ...props
}: NumberInputProps) {
  const { language } = useLanguage();

  return (
    <NumberInput
      {...props}
      decimalSeparator={decimalSeparator ?? (language === 'es' ? ',' : '.')}
      allowedDecimalSeparators={
        allowedDecimalSeparators ?? ACCEPTED_DECIMAL_SEPARATORS
      }
    />
  );
}
